<script>
	import router from 'page';
	import { onMount } from 'svelte';
	import { Entrypoint } from 'telekinesis-js';
	import * as TK from 'telekinesis-js';
	import 'purecss';

	import Freelancer from './Freelancer.svelte';
	import NewTask from './NewTask.svelte';
	import ClientDashboard from './ClientDashboard.svelte';
	import Home from './Home.svelte';
	import SignIn from './SignIn.svelte';
	import Stats from './Stats.svelte';
	import RequestEarlyAccess from './RequestEarlyAccess.svelte';
	import NavBar from './NavBar.svelte';
	import Footer from './Footer.svelte';
	import Modal from './Modal.svelte';

	import sendStats from './sendStats';

	let page;
	let backend = new Entrypoint('wss://telekinesis.cloud').get('telekinesis-inc/interviewless')();
	window.backend = backend;
	let params;
	let modalVisible = false;


	onMount(async () => {
		backend = await backend
		router('/', async () => {
			page = Home;
			params = {showEarlyAccessForm: async () => {modalVisible = true; await sendStats(backend, 'clickedMainInterestedButton', {})}}
			await sendStats(backend, 'enteredHome', {})
		})
		router('/freelancer', async () => {
			page = Freelancer;
			params = {getTask: backend.get_task}
			await sendStats(backend, 'enteredFreelancer', {})
		})
		router('/client', async () => {
			page = ClientDashboard;
			params = {};
			await sendStats(backend, 'enteredClient', {})
		})
		router('/new_task', async () => {
			page = NewTask;
			params = {addTask: backend.add_task};
			await sendStats(backend, 'enteredNewTask', {})
		})
		router('/sign_in', () => {
			page = SignIn;
			params = {signIn: backend.login};
		})
		router('/stats', () => {
			page = Stats;
			params = {stats: backend.stats};
		})
		router.start();
		window.TK = TK; 
		await sendStats(backend, 'begin', {});
	})
</script>

<NavBar>
	<a class="" href="/">
		<img src='favicon.png' class='' alt='interviewless logo' style='height: 50px;'/>
	</a>
	<a class="" href="/" style="font-weight: 800; font-size: 24px;">
		Interviewless
	</a>
	<a class="pure-button" style="margin-left: auto;" href='/sign_in'>Sign in</a>
	<!-- <button class='pure-button' style="margin-left: auto;" on:click={async () => {modalVisible = true; await sendStats(backend, 'clickedHeaderInterestedButton', {})}}>
		Interested?
		{window.innerWidth < 450 ? "Get": "Request early access" }
	</button> -->
</NavBar>

<main>
	<svelte:component this="{page}" {...params} />
	<div id='filler'></div>
</main>

<Footer>
	<p>© 2021 Telekinesis, Inc.</p>
	<!-- <a href='/stats'>stats</a> -->
</Footer>

<Modal bind:visible={modalVisible}>
	<RequestEarlyAccess submit={async (e, h, w, f) => await sendStats(backend, 'requestEarlyAccess', {email: e, hire: h, work: w, feedback: f})}/>
</Modal>

<style>
	main {
		min-height: 90vh;
		box-shadow: 0px 15px 10px -15px #aaa;
		width: 100%;
		margin: 0;
		display: flex;
		text-align: center;
		flex-direction: column;
	}
	#filler {
		width: 100%;
		/* height: 10px; */
		background-color: var(--background);
		flex-grow: 1;
	}
</style>
